import { render, staticRenderFns } from "./cultureForm.vue?vue&type=template&id=94b79b36&scoped=true"
import script from "./cultureForm.vue?vue&type=script&lang=js"
export * from "./cultureForm.vue?vue&type=script&lang=js"
import style0 from "./cultureForm.vue?vue&type=style&index=0&id=94b79b36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b79b36",
  null
  
)

export default component.exports